<template>
  <table-view ref="table" class="h-full"
    :get-params-path="getParamsPathAux"
    :get-pag="getPagAux"
    :get-excel="getExcelAux"
    :get-params="getParamsAux"
    :filter-panel="FilterPanel"
    :route-name="routeName"
    :excel-name="excelName"
    :breadcrumb-name="breadcrumbName"
    :id-vista="idVista"
    :header-title="headerTitle"
    :header-icon="headerIcon"
    :vuexnamespace="vuexnamespace"
    :payload-single-id="PayloadSingleId"
    :lista-acciones="listaAccionesFinal"
    :footer-acciones="footerAcciones"
    @executeAction="executeAction"
    @selectionChange="onSelectionChange" />
</template>

<script>
import { i18n } from '@/i18n'
import TableView from '@/components/interfaces/TableView.vue'
import CustomFilter from '@/components/filters/ClientsFilter.vue'
import { getClientsPag } from '@/services/clients/getClientsPag'
import { getClientsExcel } from '@/services/clients/getClientsExcel'
import { activateClients } from '@/services/clients/activateClients'

export default {
  name: 'clients-list-view',
  components: {
    TableView
  },
  data () {
    return {
      idVista: 8,
      FilterPanel: CustomFilter,
      vuexnamespace: 'clients',
      headerTitle: i18n.t('clients.header'),
      headerIcon: 'config',
      routeName: 'configurations/clients/details',
      excelName: `${i18n.t('clients.header').toLowerCase()}.xlsx`,
      breadcrumbName: 'Nombre',
      PayloadSingleId: 'idCliente',
      listaAcciones: [
        // { IdAccion: 700, Descripcion: i18n.t('app.edit_fields'), icon: 'editpencil' },
        { IdAccion: 701, Descripcion: i18n.t('personalization.edit_personalization'), icon: 'editpenciladd' },
        { IdAccion: 800, Descripcion: i18n.t('app.enable'), icon: 'check' },
        { IdAccion: 801, Descripcion: i18n.t('app.disable'), icon: 'cross' }
      ],
      listaAccionesFinal: [],
      footerAcciones: [{ text: i18n.t('clients.new_client'), icon: 'plus', handler: this.goToNewClient }],
      processMessage: i18n.t('app.delete_selected_confirmation', { entity: i18n.t('clients.header').toLowerCase() }),
    }
  },
  mounted () {
  },
  computed: { 
    hasModuleCustomSMTPCliente () {
      return this.$store.getters['auth/hasModuleCustomSMTPCliente']
    },
    hasModuleCustomLogo () {
      return this.$store.getters['auth/hasModuleCustomLogo']
    },
    hasModuleCustomColors () {
      return this.$store.getters['auth/hasModuleCustomColors']
    },
    hasModuleCustomMails () {
      return this.$store.getters['auth/hasModuleCustomMails']
    },
    hasModuleXslt () {
      return this.$store.getters['auth/hasModuleCustomMails']
    },
    isClientFilterActive () {
      return this.$store.getters[this.vuexnamespace + '/isClientFilterActive']
    },
    actualFilterNav () {
      return this.$store.getters['app/idClienteFilterNav']
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    disableTipoLibre () {
      return (this.role === 8 || this.role === 7) &&
       this.$store.getters['auth/idTipoProvisionamientoDistribuidor'] === 1
    }
  },
  methods: {
    getParamsPathAux (data) {
      return { id: data.idCliente }
    },
    getParamsAux (data) {
      return {
        idDistribuidor: data.distribuidor ? data.distribuidor.value?.idDistribuidor : null,
        Nombre: !this.isClientFilterActive && data.name ? data.name.value : null,
        CodigoExterno: data.codigoExterno ? data.codigoExterno.value : null,
        NumeroSerie: data.ns ? data.ns.value : null,
        idPartner: data.partner ? data.partner.value : null,
        idGrupoCliente: data.grupoCliente ? data.grupoCliente.value : null,
        idTipoServicio: data.tipoServicio ? data.tipoServicio.value : null,
        Activo: data.activo ? data.activo.value : null,
        PagarAlContabilizar: data.PagarAlContabilizar ? data.PagarAlContabilizar.value : null,
        PendienteFacturacion: data.PendienteFacturacion ? data.PendienteFacturacion.value : null,
        idCliente: this.isClientFilterActive ? this.actualFilterNav?.idCliente : null,
      }
    },
    getPagAux: async function (objOrder, params) {
      return await getClientsPag(objOrder, params)
    },
    getExcelAux: async function (objOrder, params) {
      try {
        return await getClientsExcel(objOrder, params)
      } catch (error) {}
    },
    goToNewClient: function () {
      this.$router.push({ name: 'configurations/clients/details', params: { id: -1 } })
    },
    executeAction: async function (action, selected = []) {
      if (selected.length) {
        if (action.IdAccion === 700) {
          const data = { clients: selected.map(x => x.idCliente) }
          if (this.role === 3) {
            const idDistribuidor = selected.map(x => x.idDistribuidor)[0]
            this.$router.push({ name: 'configurations/distributors/template/clients', params: { data: data, id: idDistribuidor } })
          } else {
            this.$router.push({ name: 'configurations/template/clients', params: { data: data } })
          } 
        } else if (action.IdAccion === 701) {
          const data = { clients: selected.map(x => x.idCliente) }
          if (this.role === 3) {
            const idDistribuidor = selected.map(x => x.idDistribuidor)[0]
            this.$router.push({ name: 'configurations/distributors/template/clientspersonalization', params: { data: data, id: idDistribuidor } })
          } else {
            this.$router.push({ name: 'configurations/template/clientspersonalization', params: { data: data } })
          } 
        } else if (action.IdAccion === 800) {
          this.activateHandler(true)
        } else if (action.IdAccion === 801) {
          this.activateHandler(false)
        } else {
          console.error(i18n.t('feedback.error.unexpected_action_error', { action: JSON.stringify(action) }))
        }
      }
    },
    onSelectionChange: function (selected = []) {
      let accionesFinal = []
      if (selected.length) {
        accionesFinal = this.listaAcciones
        if (this.disableTipoLibre) {
          accionesFinal = accionesFinal.filter(x => x.IdAccion !== 800).filter(x => x.IdAccion !== 801)
        } 
        const Distribuidor = selected.map(x => x.Distribuidor)[0]
        if (!this.hasModuleCustomSMTPCliente ||
          !this.hasModuleCustomLogo ||
          !this.hasModuleCustomMails ||
          !this.hasModuleCustomColors ||
          !this.hasModuleXslt ||
          !Distribuidor ||
          selected.filter(x => x.Distribuidor === Distribuidor).length !== selected.length
        ) {
          accionesFinal = accionesFinal.filter(x => x.IdAccion !== 700).filter(x => x.IdAccion !== 701)
        }
      }
      this.listaAccionesFinal = accionesFinal
    },
    activateHandler: async function (activateParam, selected = []) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          idClientes: [],
          valor: activateParam,
        }
        for (const element of selected) {
          payload.idClientes.push(element.idCliente)
        }
        const response = await activateClients(payload)
        if (response.blnError === true) {
          this.doFeedback(`${response.msgError} [${response.codError}]`)
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      this.data = await this.applyFilters()
    },
  },
}
</script>

<style scoped>

</style>
